import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import Nav from './components/Nav/Nav.js';
import ModalStart from './components/Modals/ModalStart/ModalStart.js';
import ModalHowTo from './components/Modals/ModalHowTo/ModalHowTo.js';
import ModalWin from './components/Modals/ModalWin/ModalWin.js';
import Board from './components/Game/Board/Board.js';
import Preview from './components/Game/Preview/Preview.js';
import { loadIcons } from './components/Game/getIcons.js';
import { showIcons } from './components/Game/iconSetup.js';

import arrow from './shared/assets/game/arrow.svg';
import camera from './shared/assets/game/camera.svg';
import film from './shared/assets/game/film.svg';


class Game extends Component {
    constructor(props) {
      super(props);
      const icons = loadIcons(1);
      
      this.state = {
        numIcons: icons.numIcons,
        iconOrder: icons.startOrder,
        correctOrder: icons.correctOrder,
        level: 1,
        isWon: false,
        showModalStart: true,
        showModalHowTo: false,
        showModalWin: false,
      };
    }

    //Sets showModalStart to false once the player clicks "Play" in modal.
    handlePlay = () => {
      this.setState({
        showModalHowTo: false,
        showModalStart: false,
      });
      showIcons(this.state.iconOrder, this.state.numIcons);
    }

    showModalWin = () => {
      this.setState({
        showModalWin: !this.state.showModalWin,
      });
    }

    showModalHowTo = () => {
      this.setState({
        showModalHowTo: !this.state.showModalHowTo,
      });
    }
  
    switchModalHowTo = () => {
      this.setState({
        showModalStart: false,
        showModalHowTo: true,
      });
    }

    showModalHelp = () => {
      this.setState({
        showModalHowTo: !this.state.showModalHowTo,
      });
    };

    setOrder = (imgSrc) => {
      let won = (JSON.stringify(this.state.iconOrder) === JSON.stringify(this.state.correctOrder));
      this.setState({
        iconOrder: imgSrc,
        isWon: won,
        showModalWin: won,
      });
    }

    resetHandler = () => {
      let icons = loadIcons(this.state.level);
    
      this.setState({
        iconOrder: icons.startOrder,
      }, () => {
          showIcons(this.state.iconOrder, this.state.numIcons);
      });
    }

    nextLevel = () => {
      let icons = loadIcons(this.state.level + 1);

      this.setState({
        iconOrder: icons.startOrder,
        correctOrder: icons.correctOrder,
        showModalWin: !this.state.showModalWin,
        level: this.state.level + 1,
      }, () => {
          showIcons(this.state.iconOrder, this.state.numIcons);
      });
    }

    render() {

      return (
        <div>
          <Nav resetHandler={this.resetHandler} showModal={this.showModalHowTo}/>
          <div className='content'>
            <div className='game-container'>
              <Preview numIcons={this.state.numIcons} correctOrder={this.state.correctOrder} iconOrder={this.state.iconOrder}/>

              <div className='film-reel'>
                <object className='camera' data={camera} type='image/svg+xml' aria-label='film camera icon'/>
                <object className='arrow' data={arrow} type='image/svg+xml' aria-label='clockwise arrow around game'/>
                <object className='film' data={film} type='image/svg+xml' aria-label='film strip behind game'/>
                <Board 
                  setOrder={this.setOrder} 
                  iconOrder={this.state.iconOrder} 
                  correctOrder={this.state.correctOrder}
                  numIcons={this.state.numIcons}/>
              </div>
            </div>
            <small className='copyright'>&copy; 2020 The New York Times Company</small>
          </div>

          <ModalStart onPlay={this.handlePlay} onRule={this.switchModalHowTo} show={this.state.showModalStart} />
          {this.state.isWon && this.state.showModalWin && <ModalWin onClick={this.showModalWin} playAgain={() => {this.resetHandler(); this.showModalWin();}} nextLevel={this.nextLevel} level={this.state.level}/>}
          {this.state.showModalHowTo && <ModalHowTo onPlay={this.handlePlay} onClick={this.showModalHowTo} />}
        </div>
      );
    }
}

// ===========================================

ReactDOM.render(
    <Game />,
    document.getElementById('root') 
);